import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Planning on joining other ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" To review the application process and all the detailed requirements visit ")
const _hoisted_5 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NoVisaRequired = _resolveComponent("NoVisaRequired")!
  const _component_NoVisaInformation = _resolveComponent("NoVisaInformation")!

  return (_ctx.visa !== null)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.visa.isVisaRequired)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("p", null, [
                _hoisted_3,
                _createElementVNode("button", {
                  class: "Textlink",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openLocalizationSettings()))
                }, _toDisplayString(_ctx.originCountryDemonym), 1 /* TEXT */),
                _createTextVNode(" students studying in " + _toDisplayString(_ctx.destinationCountryName) + "? Exciting! You need to apply for a visa first though. ", 1 /* TEXT */)
              ]),
              _createElementVNode("p", null, [
                _hoisted_4,
                _createElementVNode("a", { href: _ctx.countryUrl }, "The Ultimate Guide to studying in " + _toDisplayString(_ctx.destinationCountryName), 9 /* TEXT, PROPS */, _hoisted_5)
              ])
            ]))
          : (_openBlock(), _createBlock(_component_NoVisaRequired, { key: 1 }))
      ]))
    : (_openBlock(), _createBlock(_component_NoVisaInformation, { key: 1 }))
}